import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const P = styled.p`
  line-height: 1.3rem;
  min-height: 1.3rem;
  word-wrap: break-word;
`;

type Props = {
  text: string;
};

const TextAreaDisplay: FC<Props> = ({ text }) => {
  return (
    <Container>
      {text.split('\n').map((paragraph, idx) => (
        <P key={idx}>{paragraph || ' '}</P>
      ))}
    </Container>
  );
};

export default TextAreaDisplay;
